import { render, staticRenderFns } from "./selectZonaInfluencia.vue?vue&type=template&id=1b0e4110&"
import script from "./selectZonaInfluencia.vue?vue&type=script&lang=js&"
export * from "./selectZonaInfluencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
